export default __webpack_public_path__ + "static/media/2011.90566288.jpg";